// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1iooR","actions":"GroupTable_actions__OnlO3","deleteModalFooter":"GroupTable_deleteModalFooter__12SmC"};